<template>
    <base-layout>
        <template v-slot:navbar>
            <v-col class="d-flex flex-grow-1 justify-start py-0 px-0" :class="{ 'mr-n3': !tabletLayoutActive }">
                <v-col cols="7" class="d-flex justify-space-between py-0" style="padding-left: 6px; padding-right: 6px">
                    <v-card v-if="!isMobile" class="ml-0 mr-2 elevation-1 d-flex branch-navbar-card shepherd-navbar-branch-selector" height="40px" width="100%">
                        <app-bar-client-menu :disabled="!showingMultipleBranches" :isScrollable="true">
                            <template v-slot:default="slotProps">
                                <div class="d-flex align-center" v-bind="slotProps.event.attrs" v-on="slotProps.event.on" data-cy="navbar-client" :style="showingMultipleBranches ? '' : 'cursor: default'" style="width: 100%">
                                    <v-icon :class="getBranchColor" class="appbar-icon-button-small elevation-0 no-background-hover ml-2 dark-blue-color">
                                        {{ getBranchIcon }}
                                    </v-icon>

                                    <v-col class="pl-2 py-0">
                                        <div class="pb-0 d-flex justify-start align-center">
                                            <span v-if="getBranch" class="mt-1 navbar-client-name font-size-sm font-weight-bold dark-blue-color">
                                                <span>{{ getBranch }}</span>
                                            </span>
                                        </div>
                                    </v-col>

                                    <v-btn v-if="showingMultipleBranches" icon class="appbar-icon-button-small btn-bg-color-white elevation-0 mr-2">
                                        <v-icon class="dark-blue-color">mdi-chevron-down</v-icon>
                                    </v-btn>
                                </div>
                            </template>
                        </app-bar-client-menu>
                    </v-card>

                    <div class="d-flex justify-space-between ml-2 shepherd-navbar-tools" style="width: 155px; min-width: 155px; max-width: 155px">
                        <v-badge :content="getAmountUnreadNotifications" :value="getAmountUnreadNotifications" :class="calculateNavBarIconMargin()" class="badge" color="#FF3B30" data-cy="notifications-badge">
                            <app-bar-menu notificationsMenu :title="$t('layout.notifications')" :subtitle="$t('layout.markAllAsRead')" :items="getNotifications" rightIcon="mdi-chevron-right" :isScrollable="true" @open-notification="openNotification" @mark-as-read="markAsRead" @mark-all-as-read="markAllAsRead">
                                <template v-slot:default="slotProps">
                                    <v-btn
                                        v-bind="slotProps.event.attrs"
                                        v-on="slotProps.event.on"
                                        class="appbar-icon-button elevation-1"
                                        :class="[
                                            {
                                                'btn-bg-color-white': !hasUnreadNotifications,
                                                'btn-bg-color-dark-blue navbar-notif-btn-hover': hasUnreadNotifications,
                                            },
                                            calculateNavBarIconMargin(true),
                                        ]"
                                    >
                                        <v-icon
                                            :class="{
                                                'dark-blue-color': !hasUnreadNotifications,
                                                'white-color': hasUnreadNotifications,
                                            }"
                                        >
                                            mdi-bell-outline
                                        </v-icon>
                                    </v-btn>
                                </template>
                            </app-bar-menu>
                        </v-badge>

                        <v-badge :content="getAmountItems" :value="getAmountItems" :class="calculateNavBarIconMargin()" class="badge" color="#FF3B30" data-cy="cart-items-badge" v-if="showShoppingCart">
                            <v-btn
                                class="appbar-icon-button elevation-1"
                                :class="{
                                    'btn-bg-color-dark-blue': isShoppingCartDialogOpen,
                                    'btn-bg-color-white': !isShoppingCartDialogOpen,
                                }"
                                @click="openCart()"
                            >
                                <v-icon :class="isShoppingCartDialogOpen ? 'white--text' : 'dark-blue-color'"> mdi-cart-variant </v-icon>
                            </v-btn>
                        </v-badge>

                        <v-badge :content="[]" :value="0" :class="calculateNavBarIconMargin()" class="badge" color="#FF3B30" data-cy="cart-items-badge" v-else>
                            <v-btn
                                class="appbar-icon-button elevation-1 btn-bg-color-white"
                            >
                                <v-icon class="darker-gray-color"> mdi-cart-variant </v-icon>
                            </v-btn>
                        </v-badge>

                        <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" class="appbar-icon-button elevation-1 btn-bg-color-white" :class="calculateNavBarIconMargin()" :style="hasPendingProducts() ? 'cursor: pointer' : 'cursor: default'" style="margin-right: 0px" @click="openPendingProductsPage()">
                                    <v-icon v-if="hasPendingProducts()" class="red-color">
                                        {{ isPendingProductsAlertRed ? 'mdi-alert' : 'mdi-alert-outline' }}
                                    </v-icon>
                                    <v-icon v-else class="darker-gray-color" style="cursor: default; color: #737373 !important"> mdi-alert-outline </v-icon>
                                </v-btn>
                            </template>
                            <span v-if="hasPendingProducts()" class="font-size-md">{{ $t('layout.pendingProducts') }}</span>
                            <span v-else class="font-size-md">{{ $t('layout.noPendingProducts') }}</span>
                        </v-tooltip>
                    </div>
                </v-col>

                <v-col cols="5" class="d-flex flex-grow-1 justify-end py-0 wrap-search-and-user " :class="{ 'pr-5': tabletLayoutActive }">
                    <div class="d-flex shepherd-navbar-search" :class="calculateSearchMargin()" style="width: inherit; max-width: 300px" v-if="!isMobile">
                        <v-form style="width: 100%" @submit.prevent="">
                            <v-text-field
                                v-model.trim="search"
                                dense
                                solo
                                flat
                                :placeholder="$t('layout.search')"
                                height="40px"
                                prepend-inner-icon="mdi-magnify"
                                hide-details
                                class="navbar-search-text-field btn-bg-color-white dark-blue-color elevation-1"
                                style="border-radius: 8px"
                                @click:prepend-inner="searchProducts"
                                @keyup.enter="searchProducts"
                            ></v-text-field>
                        </v-form>
                    </div>
                    <div class="d-flex shepherd-navbar-search">
                        <v-btn v-if="isMobile" class="appbar-icon-button elevation-1 btn-bg-color-white" :class="calculateNavBarIconMargin()" @click="toggleSearchMobile()">
                                    <v-icon class="dark-blue-color">
                                        mdi-magnify
                                    </v-icon>
                        </v-btn>
                    </div>

                    <div class="d-flex" :class="calculateNavBarUserMargin()">
                        <v-card data-cy="navbar-user-menu" class="elevation-1 d-flex align-center shepherd-navbar-user-menu" height="40px" style="border-radius: 8px; cursor: default">
                            <app-bar-menu :items="userMenuItems" :show-user-menu="true">
                                <template v-slot:default="slotProps">
                                    <div class="d-flex align-center" v-bind="slotProps.event.attrs" v-on="slotProps.event.on">
                                        <v-btn class="appbar-icon-button-small btn-bg-color-white elevation-0 no-background-hover ml-2 btn-account" style="cursor: default">
                                            <v-icon class="dark-blue-color"> mdi-account-outline </v-icon>
                                        </v-btn>

                                        <v-btn icon class="appbar-icon-button-small btn-bg-color-white elevation-0 btn-chevron-down-up">
                                            <v-icon class="dark-blue-color"> mdi-chevron-down </v-icon>
                                        </v-btn>
                                    </div>
                                </template>
                            </app-bar-menu>
                        </v-card>
                    </div>

                    <shopping-cart-dialog @input="isShoppingCartDialogOpen = $event" :isShoppingCartDialogOpen="isShoppingCartDialogOpen" :account-blocked-message="accountBlockedMessage"></shopping-cart-dialog>

                    <div v-if="isShowFeedback">
                        <feedback-button  ></feedback-button>
                    </div>
                </v-col>
            </v-col>
        </template>

        <template v-slot:categories>
            <nav-bar-categories :title="'Categorias'" :categories="categories" :list-class="'pa-4'" :is-scrollable="false"></nav-bar-categories>
        </template>

        <template v-slot:desktop-categories>
            <template v-if="categoriesCardExpandable">
                <v-badge overlap color="transparent" :style="isCategoriesCardCollapsed ? 'width: auto' : 'width: 100%'" class="categories-container sidebar-container py-0">
                    <template v-slot:badge>
                        <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" class="appbar-icon-button-smaller btn-bg-color-secondary-blue white-color" style="cursor: pointer; border-radius: 16px; margin-left: -10px; margin-top: 20px" @click.stop="collapseCategoriesCard()">
                                    <v-icon>{{ getCollapseExpandIcon }}</v-icon>
                                </v-btn>
                            </template>

                            <span class="font-size-md">{{ getCollapseExpandTooltip }}</span>
                        </v-tooltip>
                    </template>

                    <template v-slot:default>
                        <v-navigation-drawer :mini-variant.sync="isCategoriesCardCollapsed" class="myprovet-card elevation-1 categories-container sidebar-container sidebar-nav-drawer" style="overflow-y: hidden; min-width: 72px" permanent width="100%">
                            <app-card class="sidebar-container shepherd-sidebar-categories-list fill-height">
                                <template v-slot:title>
                                    <v-card-title class="d-flex justify-space-between align-center title-text dark-blue-color mx-1" data-cy="card-title-categories">
                                        <span v-if="!isCategoriesCardCollapsed" style="overflow-x: hidden">{{ $t('layout.categories') }}</span>
                                    </v-card-title>
                                </template>

                                <template v-slot:sidebar-content-no-margin>
                                    <nav-bar-categories :title="null" :categories="getCategories" :list-class="'px-4 pt-0 pb-0'" :categoriesListHeight="categoriesListHeight"></nav-bar-categories>
                                </template>
                            </app-card>
                        </v-navigation-drawer>
                    </template>
                </v-badge>
            </template>

            <template v-else>
                <app-card class="categories-container sidebar-container shepherd-sidebar-categories-list">
                    <template v-slot:title>
                        <v-card-title class="d-flex justify-space-between align-center title-text dark-blue-color mx-1" data-cy="card-title-categories"> {{ tb('Categorias') }} </v-card-title>
                    </template>

                    <template v-slot:sidebar-content-no-margin>
                        <nav-bar-categories :title="null" :categories="categories" :list-class="'px-4 pt-0 pb-0'" :categoriesListHeight="categoriesListHeight"></nav-bar-categories>
                    </template>
                </app-card>
            </template>
        </template>

        <template v-if="hasSlot('desktop-optional')" v-slot:desktop-optional="{ alone }">
            <slot name="desktop-optional" :alone="alone" />
        </template>

        <slot />

        <confirmation-dialog :value="isLogoutConfirmDialogOpen" :isLoading="isLoggingOut || isLoggingOutWithCartItems" @onSuccess="onLogout" @onCancel="isLogoutConfirmDialogOpen = false" :title="$t('layout.attention')" :question="logoutQuestion"> </confirmation-dialog>

        <create-user-dialog v-if="isCreateUserDialogOpen" :value="isCreateUserDialogOpen" @input="isCreateUserDialogOpen = $event"></create-user-dialog>

        <user-details-dialog v-if="isUserDetailsDialogOpen" :value="isUserDetailsDialogOpen" @input="isUserDetailsDialogOpen = $event"></user-details-dialog>

        <upload-order-dialog v-if="isUploadOrderDialogOpen" :value="isUploadOrderDialogOpen" @input="isUploadOrderDialogOpen = $event"></upload-order-dialog>

        <notification-dialog v-if="isNotificationDialogOpen" :value="isNotificationDialogOpen" :notification="selectedNotification" @on-cancel="isNotificationDialogOpen = false" width="40vw" @mark-as-read="markAsRead"></notification-dialog>
    </base-layout>
</template>

<script>
import { mapStores, mapState } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { useCategoriesStore } from '@/Stores/categories';
import { useNormalOrderStore } from '@/Stores/normalorder';
import { useNotificationsStore } from '@/Stores/notifications';
import { useAppStore } from '@/Stores/app';
import { axios } from '@/Services/Backend';
import BaseLayout from './BaseLayout';
import NavBarCategories from '../Components/NavBar/Categories';
import FeedbackButton from '../Components/FeedbackButton';

export default {
    components: { NavBarCategories, FeedbackButton, BaseLayout },

    props: {
        accountBlockedMessage: String,
    },

    data: () => ({
        search: '',
        pendingProducts:[],
        userMenuItems: [
            {
                titleKey: 'layout.menu.uploadOrder',
                subtitle: '',
                icon: 'mdi-file-upload-outline',
                action: () => window.EventBus.$emit('open-upload-order-dialog'),
                permission: 'Access order upload',
            },
            {
                titleKey: 'layout.menu.createUserRequest',
                subtitle: '',
                icon: 'mdi-account-plus-outline',
                action: () => window.EventBus.$emit('open-create-user-dialog'),
                permission: 'View dialog that creates a user',
            },
            {
                titleKey: 'layout.menu.pageHelp',
                subtitle: '',
                icon: 'mdi-help-circle-outline',
                action: () => window.EventBus.$emit('start-tutorial'),
                isTutorialButton: true,
                dataCy: 'start-tutorial-button',
            },
            {
                titleKey: 'layout.menu.backoffice',
                subtitle: '',
                icon: 'mdi-cog-outline',
                route: '/backoffice',
                action: () => window.EventBus.$emit('change-route'),
                permission: 'Access backoffice',
            },
            {
                titleKey: 'layout.menu.tutorials',
                subtitle: '',
                icon: 'mdi-clipboard-text-play-outline',
                route: '/tutorials',
                action: () => window.EventBus.$emit('tutorials'),
                //permission: true,
            },
            {
                titleKey: 'layout.menu.profilesManagement',
                subtitle: '',
                icon: 'mdi-account-key-outline',
                route: '/profiles-management',
                action: () => window.EventBus.$emit('profiles-management'),
                permission: 'Access Profiles Management',
            },
            {
                titleKey: 'layout.menu.advertisementDashboard',
                subtitle: '',
                icon: 'mdi-bullhorn-outline',
                route: '/advertisement-dashboard',
                action: () => window.EventBus.$emit('advertisement-dashboard'),
                permission: 'Access Advertisement Dashboard',
            },
            {
                titleKey: 'layout.menu.logout',
                subtitle: '',
                icon: 'mdi-logout-variant',
                route: '/logout',
                action: () => window.EventBus.$emit('open-confirm-dialog', 'logout'),
            },
        ],

        categoriesListHeight: '42vh',
        navigationDrawerHeight: '50vh',
        categoriesCardExpandable: true,

        isNotificationsDialogOpen: false,
        isShoppingCartDialogOpen: false,
        isUploadOrderDialogOpen: false,
        isCreateUserDialogOpen: false,
        isUserDetailsDialogOpen: false,
        isLogoutConfirmDialogOpen: false,
        isNotificationDialogOpen: false,
        isLoggingOut: false,
        isLoggingOutWithCartItems: false, // Keeps the correct logout message after the local branch data is cleared

        pendingProductsTimer: null,
        isPendingProductsAlertRed: false,
        pendingProducts: [],
        isShowFeedback:false,
    }),

    created() {
        this.categoriesStore.readIsCategoriesCardCollapsed();
    },

    mounted() {
        this.showFeedback()
        window.EventBus.$on('open-confirm-dialog', () => {
            this.isLogoutConfirmDialogOpen = true;
        });

        window.EventBus.$on('change-route', () => {
            window.open('/backoffice', '_blank');
        });
        window.EventBus.$on('profiles-management', () => {
            this.$inertia.visit('/profiles-management')
        });
        window.EventBus.$on('tutorials', () => {
            this.$inertia.visit('/tutorials')
        });
        window.EventBus.$on('advertisement-dashboard', () => {
            this.$inertia.visit('/advertisement-dashboard')
        });
        window.EventBus.$on('open-create-user-dialog', () => {
            this.isCreateUserDialogOpen = true;
        });

        window.EventBus.$on('open-user-details-dialog', () => {
            this.isUserDetailsDialogOpen = true;
        });

        window.EventBus.$on('open-upload-order-dialog', () => {
            if (this.normalOrderStore.getIsPendingCart) {
                this.showError(this.$t('layout.unavailableInPendingCart'));
            } else {
                this.isUploadOrderDialogOpen = true;
            }
        });

        window.EventBus.$on('export-failed', () => {
            this.showError(this.$t('layout.exportError'));
        });
        window.EventBus.$on('collapse-categories-card',()=>{
            //console.log('collapse-categories-card');
            if (!this.isCategoriesCardCollapsed) {
                this.collapseCategoriesCard()
            }
        });
    },

    computed: {
        ...mapStores(useUserStore, useBranchStore, useCategoriesStore, useNormalOrderStore, useNotificationsStore, useAppStore),

        ...mapState(useCategoriesStore, {
            isCategoriesCardCollapsed: 'isCategoriesCardCollapsed',
            categories: 'categories',
        }),

        mobileLayoutActive() {
            return window.innerWidth <= 760
            //return ['xs'].includes(this.$vuetify.breakpoint.name);
        },

        tabletLayoutActive() {
            return ['xs', 'sm', 'md'].includes(this.$vuetify.breakpoint.name);
        },

        getAmountItems() {
            return this.normalOrderStore.getProductCount + this.normalOrderStore.getCampaignCount;
        },

        getBranch() {
            if (!this.branchStore.branch) return '';

            const name = this.branchStore.branch.name;
            const branch_id = this.branchStore.branch.id;

            // @Note: Get pending products for the selected branch
            if (this.userStore.hasPermissionTo('View pending products')) {
                this.getBranchPendingProducts(branch_id);
            }

            return this.userStore.hasPermissionTo('View client and branch number') ? `(${branch_id}) ${name} ` : name;
        },

        getBranchIcon() {
            const branch = this.branchStore.branch;
            if (!branch) return '';

            return branch.is_petfood ? 'mdi-alpha-p' : 'mdi-alpha-f';
        },

        getBranchColor() {
            const branch = this.branchStore.branch;
            if (!branch) return '';

            return branch.is_petfood ? 'btn-bg-color-navbar-petfood-inactive' : 'btn-bg-color-blue';
        },

        getCollapseExpandIcon() {
            return this.isCategoriesCardCollapsed ? 'mdi-chevron-right' : 'mdi-chevron-left';
        },

        getCollapseExpandTooltip() {
            return this.tb(this.isCategoriesCardCollapsed ? 'Mostrar' : 'Esconder');
        },

        getCategories() {
            if (!this.isCategoriesCardCollapsed) {
                return this.categories;
            }

            let newCategories = JSON.parse(JSON.stringify(this.categories));

            return newCategories.map((category) => {
                if ('subcategories' in category && category.subcategories.length) {
                    category.url = category.subcategories[0].url;
                    delete category.subcategories;
                }

                category.expanded = false;
                category.active = false;

                return category;
            });
        },

        getNotifications() {
            return this.notificationsStore.getNotifications;
        },

        hasUnreadNotifications() {
            let index = this.notificationsStore.getNotifications.findIndex((x) => x.read === false);
            return index >= 0;
        },

        getAmountUnreadNotifications() {
            return this.notificationsStore.getNotifications.filter((x) => x.read === false).length;
        },

        hasItemsInCart() {
            return this.normalOrderStore.getProductCount > 0 || this.normalOrderStore.getCampaignCount > 0;
        },

        logoutQuestion() {
            return this.hasItemsInCart || this.isLoggingOutWithCartItems ? this.$t('layout.logoutQuestionWithCart') : this.$t('layout.logoutQuestion');
        },

        showingMultipleBranches() {
            return this.userStore.branchCount > 1 || this.userStore.hasPermissionTo('Access all clients and branches');
        },
        isMobile(){
            return this.appStore.mobile_ls?false:this.appStore.is_mobile;
        },
        isSearchMobile(){
            return this.appStore.is_search_mobile
        },
        showShoppingCart(){
            return this.userStore.hasPermissionTo('View normal order');
        }
    },

    watch: {
        pendingProducts: {
            handler: function () {
                this.checkPendingProducts();
            },
            immediate: true,
        },

        '$page.url': {
            handler: function (url) {
                url === '/dashboard' ? (this.categoriesCardExpandable = false) : (this.categoriesCardExpandable = true);
            },
            immediate: true,
        },
    },

    methods: {
        showFeedback(){
            //console.log(window.location,this,window.EventBus,this.$tawkMessenger.hideWidget());
           //console.log(this.isMobile,_.clone(window.location.pathname),window.location,this,window.EventBus)
           if(!this.isMobile && window.innerWidth>1224){
               if(_.has(window.Tawk_API,'showWidget'))
                    setTimeout(()=>{
                        window.Tawk_API.showWidget();
                    })
                setTimeout(()=>{
                    //console.log( window.Tawk_API)
                    if(_.has(window.Tawk_API,'showWidget'))
                        window.Tawk_API.showWidget();
                },2800)
                this.isShowFeedback=true;
                //return true
           }else{
            if(this.isMobile && window.location.pathname=='/dashboard' || window.location.pathname=='/dashboard' && window.innerWidth<=1224 || window.location.pathname=='/index.php/dashboard' || window.location.pathname=='/index.php/index.php/dashboard'){
                //window.Tawk_API.showWidget();
                if(_.has(window.Tawk_API,'showWidget'))
                    setTimeout(()=>{
                        window.Tawk_API.showWidget();
                    })
                setTimeout(()=>{
                    //console.log( window.Tawk_API)
                    if(_.has(window.Tawk_API,'showWidget'))
                        window.Tawk_API.showWidget();
                },2800)
                this.isShowFeedback=true;
                //return true
            }else{
                if(_.has(window.Tawk_API,'hideWidget'))
                    setTimeout(()=>{
                            window.Tawk_API.hideWidget();
                    });

                setTimeout(()=>{
                    //console.log( window.Tawk_API)
                    if(_.has(window.Tawk_API,'hideWidget'))
                        window.Tawk_API.hideWidget();
                },2800)
                //window.Tawk_API.hideWidget();
                //$('.widget-visible').hide();
                //if( document.getElementsByClassName('widget-visible').length>0)
                 //   document.getElementsByClassName('widget-visible')[0].style.visibility = 'hidden!important';
                //document.body.classList.add('hideTawkTo');
                this.isShowFeedback=false;
                //return false
            }
           }
        },
        toggleSearchMobile(){
            let value = !this.appStore.is_search_mobile
            this.appStore.setSearchMobile(value)
        },
        openNotification(item) {
            this.selectedNotification = item;
            this.isNotificationDialogOpen = true;
        },

        markAsRead(notification) {
            this.notificationsStore.markAsRead(notification);
        },

        markAllAsRead() {
            this.notificationsStore.markAllAsRead();
        },

        hasSlot(name = 'default') {
            if (!!this.$slots[name] || !!this.$scopedSlots[name]) {
                this.categoriesListHeight = '42vh';
                this.navigationDrawerHeight = '50vh';
            } else {
                this.categoriesListHeight = '73.5vh';
                this.navigationDrawerHeight = '81vh';
            }

            return !!this.$slots[name] || !!this.$scopedSlots[name];
        },

        getNavBarSearchWidth() {
            return this.$vuetify.breakpoint.name == 'xl' ? 'max-width: 19.6vw; min-width: 19.6vw;' : '';
        },

        calculateNavBarIconMargin(noMargin = false) {
            switch (this.$vuetify.breakpoint.name) {
            case 'xs':
            case 'sm':
                return 'ml-1';
            case 'md':
                return noMargin ? 'mx-0' : 'mx-1';
            case 'lg':
            case 'xl':
            default:
                return noMargin ? 'mx-0' : 'mx-1';
            }
        },

        calculateSearchMargin() {
            switch (this.$vuetify.breakpoint.name) {
            case 'xs':
            case 'sm':
            case 'md':
                return 'ml-1';
            case 'lg':
            case 'xl':
            default:
                return 'ml-8';
            }
        },

        calculateNavBarUserMargin() {
            switch (this.$vuetify.breakpoint.name) {
            case 'xs':
            case 'sm':
            case 'md':
                return 'ml-1';
            case 'lg':
            case 'xl':
            default:
                return 'ml-6';
            }
        },

        searchProducts() {
            //const url = route('order.normal', { q: this.search });
            let targetView = this.userStore.hasPermissionTo('View normal order')?'order.normal':'products.simposium';
            const url = route(targetView, { q: this.search });
            // After searching something we need to clear it to avoid
            //  misunderstandings if we're already in the orders page.
            this.search = '';

            this.$inertia.visit(url);
        },

        onLogout() {
            this.hasItemsInCart ? (this.isLoggingOutWithCartItems = true) : (this.isLoggingOut = true);
            this.userStore.logout(this.$inertia, this.$tawkMessenger);
        },

        openCart() {

            if (this.branchStore.isBlocked) {
                this.showError(this.accountBlockedMessage);
                return;
            }
            var element = document.getElementById("app");
            element.classList.add("fix-background");
            this.isShoppingCartDialogOpen = true;
        },

        hasPendingProducts() {
            return this.pendingProducts.length > 0;
        },

        checkPendingProducts() {
            if (this.hasPendingProducts()) {
                this.pendingProductsTimer = setInterval(() => {
                    this.isPendingProductsAlertRed = !this.isPendingProductsAlertRed;
                }, 1500);
            } else {
                clearInterval(this.pendingProductsTimer);
                this.pendingProductsTimer = null;
            }
        },

        collapseCategoriesCard() {
            this.categoriesStore.setIsCategoriesCardCollapsed(!this.isCategoriesCardCollapsed);
            let element= document.getElementById("pg_content");
            if(this.categoriesStore.isCategoriesCardCollapsed){

                element.classList.add('collapsed')
            }else{
                element.classList.remove('collapsed')
            }
            //console.log('collapseCategoriesCard');
            //window.EventBus.$emit('update:areaChart', true )
        },

        openPendingProductsPage() {
            if (this.hasPendingProducts()) this.$inertia.visit(route('order.pending_products'));
        },

        getBranchPendingProducts(branch_id) {
            this.pendingProducts = [];

            axios
                .get(`/api/orders/has-pending-products/${branch_id}`)
                .then((response) => {
                    this.pendingProducts = response.data;
                    this.pendingProducts.length > 0 ? this.branchStore.setHasPendingProducts(true) : this.branchStore.setHasPendingProducts(false);
                })
                .catch((error) => {
                    console.log(error);
                    this.showError(this.$t('layout.pendingProductsError'));
                    this.branchStore.setHasPendingProducts(false);
                });
        },
    },

    beforeDestroy() {
        window.EventBus.$off('open-confirm-dialog');
        window.EventBus.$off('change-route');
        window.EventBus.$off('open-create-user-dialog');
        window.EventBus.$off('open-user-details-dialog');
        window.EventBus.$off('collapse-categories-card');
    },
};
</script>

<style>
.navbar-search-text-field > .v-input__control > .v-input__slot {
    min-height: inherit !important;
}

.navbar-search-text-field > .v-input__control > .v-input__slot > .v-text-field__slot > input {
    margin-top: 2px !important;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
}

.sidebar-nav-drawer {
    padding-bottom: 0px;
}

.sidebar-nav-drawer > .v-navigation-drawer__content {
    display: flex;
}
</style>

<style scoped>
.branch-navbar-card {
    border-radius: 8px;
    cursor: default;
}

.navbar-client-name {
    word-break: normal;
    white-space: initial;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
</style>
